import type { CityConfig } from "../city-template/types";

export const bethesdaConfig: CityConfig = {
  city: "Bethesda",
  state: "Maryland",
  stateAbbr: "MD",
  slug: "bethesda",
  route: "/cities/bethesda",
  title: "Emergency Passport Bethesda MD | Expedited Passport Processing | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Bethesda, Maryland — as fast as 24 hours. Fast passport renewal and new passport applications for Bethesda, Chevy Chase, Potomac, and Kensington residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Bethesda, MD",
  heroSubtitle: "Bethesda travelers — from NIH researchers to Walter Reed families to downtown professionals — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Montgomery County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Elegant%20view%20of%20Bethesda%20Maryland%20downtown%20along%20Wisconsin%20Avenue%20with%20modern%20upscale%20buildings%2C%20tree-lined%20streets%2C%20NIH%20campus%20visible%20in%20the%20distance%2C%20warm%20afternoon%20golden%20hour%20lighting%2C%20professional%20urban%20photography%2C%20clean%20architectural%20details%2C%20no%20visible%20text%20or%20people%2C%20soft%20green%20foliage%20and%20sophisticated%20city%20atmosphere&width=1800&height=700&seq=bethesda-hero-001&orientation=landscape",
  heroImageAlt: "View of Bethesda Maryland downtown along Wisconsin Avenue with modern buildings and tree-lined streets",
  geoPosition: "38.9847;-77.0947",
  geoPlacename: "Bethesda, Maryland",
  lastModified: "2026-06-01",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, 1st Floor, Washington, DC 20006",
    distance: "Approximately 25–35 minutes from Bethesda via I-495 S and I-66 E",
  },
  nearbyCitiesZips: [
    { name: "Bethesda", zips: "20814, 20815, 20816, 20817, 20824, 20827, 20889, 20892, 20894" },
    { name: "Chevy Chase", zips: "20814, 20815, 20825" },
    { name: "Potomac", zips: "20854, 20859" },
    { name: "Kensington", zips: "20891, 20895" },
    { name: "Glen Echo", zips: "20812" },
    { name: "Cabin John", zips: "20818" },
    { name: "North Bethesda", zips: "20852, 20895" },
    { name: "Takoma Park", zips: "20901, 20910, 20912, 20913" },
    { name: "Silver Spring", zips: "20901, 20902, 20903, 20904, 20905, 20906, 20910, 20911" },
    { name: "Rockville", zips: "20847, 20848, 20849, 20850, 20851, 20852, 20853, 20857" },
    { name: "Gaithersburg", zips: "20877, 20878, 20879, 20882, 20883, 20884, 20885, 20898, 20899" },
    { name: "McLean", zips: "22101, 22102, 22106, 22107" },
    { name: "Arlington", zips: "22201, 22202, 22203, 22204, 22205, 22206, 22207, 22209, 22211, 22213, 22214" },
    { name: "Washington DC", zips: "20001, 20002, 20003, 20004, 20005, 20006, 20007, 20008, 20009, 20010, 20011, 20012, 20015, 20016, 20017, 20018, 20019, 20020, 20024, 20032, 20036, 20037, 20045, 20052, 20057, 20059, 20064" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier for Bethesda and DC metro departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-hospital-line", title: "Medical & Research Hub", desc: "Serving NIH, Walter Reed, and Suburban Hospital travelers" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no trip to downtown DC" },
  ],
  internalLinks: [
    { name: "Expedited passport in Rockville, MD", route: "/cities/rockville" },
    { name: "Emergency passport help in Silver Spring, MD", route: "/cities/silver-spring" },
    { name: "Urgent passport services in Columbia, MD", route: "/cities/columbia" },
    { name: "Maryland passport services overview", route: "/states/maryland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Bethesda, Maryland remotely via secure registered courier. We do not have a walk-in office in Bethesda — our registered couriers hand-deliver your documents to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Bethesda metro travelers without the drive to downtown DC.",
  fpcOfficeDistance: "Serving Bethesda, Chevy Chase, Potomac, Kensington, and greater Montgomery County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout the Bethesda area and greater Montgomery County. From the NIH campus and Walter Reed National Military Medical Center to the upscale neighborhoods of Chevy Chase and Potomac, from the bustling downtown along Wisconsin Avenue to the quiet residential streets of Glen Echo and Cabin John — we serve all of Bethesda's diverse communities.",
  nearbyCitiesIntro: "We serve Bethesda and nearby communities including Chevy Chase, Potomac, Kensington, Glen Echo, Cabin John, North Bethesda, Takoma Park, Silver Spring, Rockville, and Gaithersburg. We also serve cross-border DC and Northern Virginia residents in McLean and Arlington who prefer our expedited service.",
  howItWorksIntro: "Most Bethesda travelers complete everything online and ship documents overnight. No need to drive 25–35 minutes to downtown DC or navigate the Capital Beltway during rush hour.",
  mistakesIntro: "Bethesda is a major medical and research travel hub with a highly educated, internationally mobile population. Here are the most common passport mistakes we see from Bethesda travelers.",
  testimonialsIntro: "Bethesda travelers — from NIH researchers to military families to international professionals — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Bethesda, MD? Here are the most common ones we hear from Montgomery County travelers.",
  statePageRoute: "/states/maryland",
  statePageName: "Maryland",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 25–35 min to downtown DC", "Full day commitment — challenging for working professionals"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Perfect for medical and research travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Bethesda travelers with immediate departure needs — as fast as 24 hours. Perfect for medical conferences, research trips, and last-minute international travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Medical and research travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Bethesda adults with a passport issued within the last 15 years.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to Bethesda address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Bethesda residents and families — including international researchers and visiting scholars.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Bethesda residents who lost their passport before travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Bethesda families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Bethesda residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Bethesda MD", description: "Urgent passport processing for Bethesda Maryland travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Bethesda MD", description: "Fast passport renewal for Bethesda Maryland residents with a previously-issued passport." },
    { name: "First-Time Passport Bethesda MD", description: "New passport application services for Bethesda Maryland residents applying for their first passport." },
    { name: "Child Passport Bethesda MD", description: "Minor passport services for Bethesda Maryland families with children under 16." },
  ],
  testimonials: [
    {
      name: "Dr. Sarah K.",
      location: "NIH, Bethesda",
      rating: 5,
      text: "Conference in Tokyo in 4 days. Fast Passport Center reviewed every document, caught a minor form issue, and delivered my passport in 36 hours. Absolutely essential for researchers with tight travel schedules.",
      service: "Emergency Passport",
    },
    {
      name: "Robert M.",
      location: "Chevy Chase, MD",
      rating: 5,
      text: "Family vacation to Italy with 9 days notice. Three passports processed in under a week. The agent handled everything — we just shipped the documents from the UPS Store on Wisconsin Ave.",
      service: "Family Passport Bundle",
    },
    {
      name: "Jennifer L.",
      location: "Potomac, MD",
      rating: 5,
      text: "Business trip to London with 7 days notice. Fast Passport Center had my renewed passport ready in 2 days. No need to drive to DC — everything shipped overnight.",
      service: "Passport Renewal",
    },
    {
      name: "Col. David T.",
      location: "Walter Reed, Bethesda",
      rating: 5,
      text: "Last-minute deployment required updated passport. They understood the urgency and had it in my hands within 48 hours. Professional service that understands military timelines.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "bethesda-1",
      name: "Bethesda Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7400 Wisconsin Ave",
      city: "Bethesda",
      state: "MD",
      zip: "20814",
      phone: "(301) 657-8002",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Bethesda, on Wisconsin Avenue",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary downtown Bethesda acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient Metro access via Bethesda Station on the Red Line.",
      icon: "ri-mail-line",
    },
    {
      id: "bethesda-2",
      name: "Chevy Chase Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5500 Connecticut Ave NW",
      city: "Washington",
      state: "DC",
      zip: "20015",
      phone: "(202) 244-3725",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Chevy Chase, DC border — approximately 2 miles from downtown Bethesda",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Chevy Chase residents and those near the DC border. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "bethesda-3",
      name: "Potomac Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10601 River Rd",
      city: "Potomac",
      state: "MD",
      zip: "20854",
      phone: "(301) 983-2182",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Potomac, approximately 5 miles northwest of Bethesda",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for Potomac and western Montgomery County residents. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "bethesda-4",
      name: "Kensington Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3712 Decatur Ave",
      city: "Kensington",
      state: "MD",
      zip: "20895",
      phone: "(301) 949-3650",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Kensington, approximately 3 miles east of Bethesda",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving Kensington and eastern Montgomery County residents. Good alternative when Bethesda appointments are full.",
      icon: "ri-mail-line",
    },
    {
      id: "bethesda-5",
      name: "Montgomery County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "50 Maryland Ave",
      city: "Rockville",
      state: "MD",
      zip: "20850",
      phone: "(240) 777-9460",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Rockville, approximately 6 miles north of Bethesda",
      website: "https://www.montgomerycountymd.gov/",
      websiteLabel: "Montgomery County",
      notes: "County-level facility with full passport acceptance. Extended hours compared to post office locations. Accessible via Metro Red Line to Rockville Station.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited DC slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 25–35 min drive to downtown DC", fpc: "No — ship from Bethesda" },
    { feature: "Medical Travel Support", agency: "No flexibility for research needs", fpc: "Yes — we handle medical and academic cases" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Bethesda's busy medical and research professionals often discover passport needs just weeks before departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Local photo services in Bethesda sometimes produce photos that meet general ID requirements but not passport standards. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Bethesda and Montgomery County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking the Acceptance Facility Early",
      description: "Bethesda Post Office appointments fill up fast, especially during summer and holiday travel seasons. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Government fees change periodically. Always verify current fees before submitting — incorrect payment means starting over.",
    },
    {
      icon: "ri-time-line",
      title: "Underestimating Routine Processing Time",
      description: "Bethesda residents often assume 4–6 weeks is enough. Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your home in Bethesda, Chevy Chase, or Potomac." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx location near downtown Bethesda or along River Road." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Bethesda address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Bethesda, MD?", a: "Fast Passport Center offers emergency passport processing in Bethesda, Maryland in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Washington DC Passport Agency (25–35 minutes from Bethesda) — without you needing to make the drive or fight Beltway traffic." },
    { q: "Does Bethesda have its own passport agency?", a: "No — neither Bethesda nor the state of Maryland has a regional passport agency. The closest facility is the Washington DC Passport Agency, approximately 25–35 minutes from Bethesda via I-495 S. Fast Passport Center's courier service means Bethesda residents never need to make that drive." },
    { q: "Can I get expedited passport services if I live in Chevy Chase or Potomac?", a: "Absolutely. Fast Passport Center serves all of the Bethesda area including Chevy Chase, Potomac, Kensington, Glen Echo, and Cabin John. We also serve North Bethesda, Takoma Park, and Silver Spring residents. Our service works the same way — complete your application online, ship your documents, and we handle the rest." },
    { q: "How much does an expedited passport cost in Bethesda, MD?", a: "Government fees are fixed: $130 for a first-time passport book or $130 + $60 expedite for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your departure timeline." },
    { q: "What airports do Bethesda travelers use for international flights?", a: "Most Bethesda residents fly internationally through Dulles International Airport (IAD), approximately 30–40 minutes west via the Dulles Toll Road. Reagan National (DCA) is closer at 20–30 minutes and offers domestic connections. Baltimore-Washington International (BWI) is 45–55 minutes northeast. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "Can I get a passport for my whole family in Bethesda?", a: "Yes. Fast Passport Center handles multi-passport cases for families in Bethesda, Chevy Chase, Potomac, and surrounding areas. Whether you need child passports, renewals, or first-time applications for the whole family, we coordinate the process to ensure everyone is ready to travel." },
    { q: "Where is the closest passport acceptance facility to downtown Bethesda?", a: "The Bethesda Post Office at 7400 Wisconsin Ave is the primary downtown acceptance facility. The Chevy Chase Post Office at 5500 Connecticut Ave NW serves residents near the DC border. The Potomac Post Office at 10601 River Rd serves western Montgomery County. All require appointments — book 1–2 weeks ahead." },
    { q: "How do I know if I need expedited or routine passport processing?", a: "If your travel is within 10 weeks, use expedited service. If your travel is within 2–3 weeks, use emergency expedited service. Routine processing takes 6–13 weeks and is only suitable for travel more than 3 months away. Bethesda residents should plan ahead, especially for medical conferences and international research travel." },
  ],
  photoLocations: [
    { name: "Walgreens — Bethesda", address: "7101 Wisconsin Ave, Bethesda, MD 20814", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Bethesda", address: "10401 Old Georgetown Rd, Bethesda, MD 20814", hours: "Mon–Sun: 8AM–10PM" },
    { name: "UPS Store — Chevy Chase", address: "5530 Wisconsin Ave, Chevy Chase, MD 20815", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Potomac", address: "10800 Connecticut Ave, Kensington, MD 20895", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "MVA — Gaithersburg", address: "15 Metropolitan Grove Rd, Gaithersburg, MD 20878", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Serves Montgomery County and northwest DC metro. REAL ID processing available.", featured: true },
    { name: "MVA — White Oak", address: "12335 Columbia Pike, Silver Spring, MD 20904", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Serves eastern Montgomery County and Silver Spring area. Full service including REAL ID.", featured: false },
  ],
  airports: [
    {
      code: "IAD",
      name: "Dulles International",
      distance: "30–40 minutes from Bethesda via Dulles Toll Road",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Primary international departure airport for Bethesda travelers. Direct flights to London, Frankfurt, Tokyo, and major European hubs. United Airlines hub.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Flight Info",
      featured: true,
    },
    {
      code: "DCA",
      name: "Reagan National (Washington DC)",
      distance: "20–30 minutes from Bethesda via I-495 S",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "Closest airport for domestic connections. Limited international flights but excellent for connecting to major hubs.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Flight Info",
      featured: false,
    },
    {
      code: "BWI",
      name: "Baltimore-Washington International Thurgood Marshall",
      distance: "45–55 minutes from Bethesda via I-495 E",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Alternative for Southwest Airlines domestic connections and some Caribbean destinations.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Flight Info",
      featured: false,
    },
  ],
};